import React from 'react';
import '../../styles/site.css';

const Banner = () => {
    return (
        <div className="row row-banner">
            <div className="col-sm-2 sinPadding">
                {/* <img src="https://csintercelulas.s3.amazonaws.com/code/media/csbanner.png" className="img-responsive cs-banner" alt="" /> */}
                <img src="https://appsd.compusoluciones.com/csEstilos/csImagenes/imgCS.png" className="img-responsive cs-banner" alt="" />
            </div>
            <div className="col-sm-10 col-banner">
                {/* <img src="https://csintercelulas.s3.amazonaws.com/code/media/febanner.png" className="img-responsive fe-banner" alt="" /> */}
                {/* <img src="https://appsd.compusoluciones.com/csEstilos/csImagenes/imgSistema.png" className="img-responsive fe-banner" alt="" /> */}
                <img src="https://appsd.compusoluciones.com/csEstilos/csImagenes/bannerAltaClientesCol.png" className="img-responsive fe-banner" alt="" />
            </div>
        </div>        
    )
}
/* retorna true si al pasar los nextProps a renderizar retorna el mismo resultado que al pasar los prevProps a renderizar, de otro modo retorna false */
function validaProps(prevProps, nextProps) {
    // console.log(equalarray(prevProps.poliza, nextProps, (prevProps.value === nextProps.value), (JSON.stringify(prevProps.poliza[0]) === JSON.stringify(nextProps.poliza[0]))); 
    //si retorna un falso renderiza todo el componente, porque si es falso significa que el valor cambio
    //falso es igual que son diferentes
    //si son muchos objetos va si [0]
    return (prevProps.start === nextProps.start);
  }

export default React.memo(Banner, validaProps);